import { ArrowSplitVerticalIcon } from './ArrowSplitVerticalIcon';

/**
 * author: Michael Richins
 * id 7234382E-CB5D-4EB3-8BA2-0C50BC2171DB
 * name arrow-split-vertical
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-split-vertical.svg
 * tags
 * - Arrow 
 */
export const ResizeHorizontalIcon = ArrowSplitVerticalIcon;
export default ResizeHorizontalIcon